import styled from '@emotion/styled'

export const IndexStyled = styled.div``
